
import { defineStore } from "pinia"
import { ref } from 'vue'

export const usePageVisibilityStore = defineStore('pageVisibility', () => {
  // ページの表示状態 true: 表示中, false: 非表示
  const pageVisible = ref(true)
  const updatePageVisible = (newPageVisible: boolean) => {
    pageVisible.value = newPageVisible
  }
  return {
    pageVisible,
    updatePageVisible
  }
})
